<template>
  <div class="kanban-group-operations-quota">
    <template v-if="quota">
      {{ $t('smsLeft') }}: {{ quota.sms }}
      <v-alert v-if="selectedCandidates.length > quota.sms" type="error">
        <v-row no-gutters>
          <v-col cols="6">
            {{ $t('smsQuotaExceeded') }}
          </v-col>
          <v-col cols="6">
            <VBtn
              @click="changePlan()"
              class="dashboard-plan__change"
              outlined
              block
            >
              <v-icon dense class="mx-4">
                mdi-pencil
              </v-icon>
              {{ $t('changePlan') }}
            </VBtn>
          </v-col>
        </v-row>
      </v-alert>
    </template>
    <div v-else class="kanban-group-operations-quota__loading d-flex align-center">
      <v-progress-circular indeterminate size="20" width="2" color="primary" class="mr-2" />
    </div>
  </div>
</template>

<script>
import { onMounted } from '@vue/composition-api';
import { useKanbanMultipleOperations } from '@/compositions/useKanbanMultipleOperations';
import useAccount from '@/compositions/accounting/useAccount';
import { paymentTabs, settingsTabs } from '@/enums';

export default {
  name: 'KanbanOperationsQuota',
  setup(_, { root: { $router } }) {
    const { selectedCandidates } = useKanbanMultipleOperations();
    const { quota, fetchIfNull } = useAccount();

    onMounted(() => {
      fetchIfNull();
    });

    function changePlan() {
      $router.push({ name: 'settings', params: { type: settingsTabs.PAYMENT, addType: paymentTabs.PLANS } });
    }

    return {
      selectedCandidates,
      quota,
      changePlan,
    };
  },
};
</script>

<style scoped lang="scss">
.kanban-group-operations-quota__loading {
  min-height: 32px;
}
</style>

<i18n lang="yml" locale="ru">
smsLeft: Осталось SMS
smsQuotaExceeded: Недостаточно SMS для отправки
changePlan: Изменить тариф
</i18n>

<i18n lang="yml" locale="en">
smsLeft: Messages left
smsQuotaExceeded: Messages quota exceeded
changePlan: Change plan
</i18n>
